import { useTranslation } from "react-i18next";
import { ColorScheme } from "../../../../Themes/ColorScheme";

export const FormEdit = ({
    title,
    value,
    type = "text",
    changeData,
    isMultiRow,
    rowAmount = 1,
    isRequired,
    hasCharLimit,
    centeredText
}) => {

    const { t } = useTranslation();

    const handleChange = (event) => {
        changeData(event.target.value);
    };

    const containerStyle = {
        margin: "10px 0"
    };

    const labelStyle = {
        display: "block",
        marginBottom: "5px",
        fontWeight: "bold",
        color: isRequired && value == "" ? ColorScheme.dangerPrimary : ColorScheme.secondary
    };

    const inputStyle = {
        width: "100%",
		minHeight: "60px",
		fontSize: "16px",
        padding: "8px",
		backgroundColor: ColorScheme.white,
        marginBottom: "5px",
        border: "1px solid " + ColorScheme.lightGrey,
        borderRadius: "4px",
        boxSizing: "border-box",
        textAlign: centeredText ? "center" : "left",
		color: ColorScheme.black,
		fontFamily: "inherit"
    };

    const charLimitStyle = {
        display: "inline", // changed from "block"
        marginLeft: 8,
        fontSize: "0.875em",
        color: ColorScheme.textSecondaryLight,
        marginTop: 0 // ensure no extra top margin
    };

    return (
    <div style={containerStyle}>
        {title && (
            <label style={labelStyle}>
                {title}
                {hasCharLimit && (
                    <small style={{ ...charLimitStyle, marginLeft: 8, marginTop: 0 }}>
                        {value?.length || 0} / 255 merkkiä
                    </small>
                )}
                {isRequired && value == "" && (
                    " - " + t("textfield_labels.required_field")
                )}
            </label>
        )}
        {isMultiRow ? (
            <textarea
                value={value || ""}
                rows={rowAmount}
                required={isRequired}
                maxLength={hasCharLimit ? 255 : undefined}
                onChange={handleChange}
                style={inputStyle}
            />
        ) : (
            <input
                type={type}
                value={value || ""}
                required={isRequired}
                maxLength={hasCharLimit ? 255 : undefined}
                onChange={handleChange}
                style={inputStyle}
            />
        )}
    </div>
);
};